import { request } from "./client";

// GET /tasks — active tasks with the current user's state on each
// ('available' | 'pending' | 'cooldown' | 'completed').
export const getActiveTasks = () =>
  request("/tasks")
    .then((res) => {
      const list = Array.isArray(res) ? res : res?.data;
      return Array.isArray(list) ? list.filter(Boolean) : [];
    })
    .catch(() => []);

export const getMyTaskSubmissions = () =>
  request("/tasks/mine/submissions")
    .then((res) => {
      const list = Array.isArray(res) ? res : res?.data;
      return Array.isArray(list) ? list.filter(Boolean) : [];
    })
    .catch(() => []);

export const submitTaskProof = (taskId, proofUrl) =>
  request(`/tasks/${taskId}/submit`, {
    method: "POST",
    body: JSON.stringify({ proofUrl }),
  });
